module.exports = __webpack_public_path__ + "static/media/giftIcon.d0dbd1ef.svg";